import { Modal } from 'antd';
import React from 'react';
import AdvancedButton from '@portal/components/AdvancedButton/AdvancedButton';
import { translate } from '@portal/services/i18n';

interface ConfirmPortabilityModalProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  onConfirm: () => void;
  onRefuse: () => void;
  loading?: boolean;
}

const ConfirmPortabilityModal = ({
  visible,
  setVisible,
  onConfirm,
  onRefuse,
  loading = false,
}: ConfirmPortabilityModalProps) => (
  <Modal
    open={visible}
    onCancel={() => setVisible(false)}
    footer={null}
    centered
    className="pix-portability-modal"
  >
    <p className="pix-portability-modal__title">
      {translate('COMPONENTS.PIX_PORTABILITY_MODAL.CONFIRM_PORTABILITY.TITLE')}
    </p>
    <p className="pix-portability-modal__text">
      {translate('COMPONENTS.PIX_PORTABILITY_MODAL.CONFIRM_PORTABILITY.TEXT')}
    </p>
    <div className="pix-portability-modal__button">
      <AdvancedButton
        text={translate(
          'COMPONENTS.PIX_PORTABILITY_MODAL.CONFIRM_PORTABILITY.CANCEL'
        )}
        variant="outlined"
        onClick={onRefuse}
        disabled={loading}
      />
    </div>
    <div className="pix-portability-modal__button">
      <AdvancedButton
        text={translate(
          'COMPONENTS.PIX_PORTABILITY_MODAL.CONFIRM_PORTABILITY.OK'
        )}
        variant="contained"
        onClick={onConfirm}
        disabled={loading}
      />
    </div>
  </Modal>
);

export default ConfirmPortabilityModal;
